// import {Component, OnChanges, Input, Output, SimpleChange, EventEmitter} from '@angular/core';
//
// @Component({
//   selector: 'app-password-strength-bar',
//   templateUrl: './password-strength-bar.component.html',
//   styleUrls: ['./password-strength-bar.component.css'],
// })
// export class PasswordStrengthBarComponent implements OnChanges {
//
//   @Input() passwordToCheck: string;
//   @Input() barLabel: string;
//
//   colorList: any = []
//
//   @Output('onPasswordChange')
//   change: EventEmitter<number> = new EventEmitter<number>();
//
//   private colors = ['#F00', '#F90', '#FF0', '#9F0', '#0F0'];
//
//   constructor() {
//     this.passwordToCheck = '';
//     this.barLabel = '';
//   }
//
//   private static measureStrength(pass: string) {
//     let score = 0;
//
//     let variations: any = {
//       digits: /\d/.test(pass),
//
//       lower: /[a-z]/.test(pass),
//
//       upper: /[A-Z]/.test(pass),
//
//       nonWords: /\W/.test(pass),
//
//       wordLength: /^.{8,15}$/.test(pass)
//     };
//
//     let variationCount: number = 0;
//
//     for (let check in variations) {
//       variationCount += variations[check] ? 1 : 0;
//     }
//
//     score += (variationCount) * 20;
//
//     return Math.trunc(score);
//   }
//
//   private getColor(score: number) {
//     let idx = 0;
//
//     if (score > 90) {
//       idx = 4;
//     } else if (score > 70) {
//       idx = 3;
//     } else if (score >= 40) {
//       idx = 2;
//     } else if (score >= 20) {
//       idx = 1;
//     }
//
//     return {
//       idx: idx + 1,
//
//       col: this.colors[idx],
//     };
//   }
//
//   ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
//     var password = changes['passwordToCheck'].currentValue;
//     this.setBarColors(5, '#DDD');
//     if (password) {
//       let score = PasswordStrengthBarComponent.measureStrength(password);
//       let c = this.getColor(score);
//       this.change.emit(score);
//       this.setBarColors(c.idx, c.col);
//     }
//   }
//
//   private setBarColors(count: number, col: any) {
//     this.colorList = [];
//     for (let _n = 0; _n < count; _n++) {
//       this.colorList.push(col);
//     }
//   }
//
// }



import { Component, OnChanges, Input, Output, SimpleChange, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-password-strength-bar',
    templateUrl: './password-strength-bar.component.html',
    styleUrls: ['./password-strength-bar.component.css'],
    standalone: false
})
export class PasswordStrengthBarComponent implements OnChanges {
  @Input() passwordToCheck: string;
  @Input() barLabel: string;

  colorList: any = [];
  unmetCriteria: string[] = []; // Track unmet criteria

  @Output('onPasswordChange') change: EventEmitter<number> = new EventEmitter<number>();

  private colors = ['#F00', '#F90', '#FF0', '#9F0', '#0F0'];

  constructor() {
    this.passwordToCheck = '';
    this.barLabel = '';
  }

  private static measureStrength(pass: string): number {
    let score = 0;

    const variations: any = {
      digits: /\d/.test(pass),
      lower: /[a-z]/.test(pass),
      upper: /[A-Z]/.test(pass),
      nonWords: /\W/.test(pass),
      wordLength: /^.{8,15}$/.test(pass),
    };

    let variationCount: number = 0;

    for (let check in variations) {
      variationCount += variations[check] ? 1 : 0;
    }

    score += variationCount * 20;

    return Math.trunc(score);
  }

  private validatePassword(password: string): void {
    const criteria = [
      { regex: /[a-z]/, message: 'At least one lowercase letter' },
      { regex: /[A-Z]/, message: 'At least one uppercase letter' },
      { regex: /\d/, message: 'At least one number' },
      { regex: /\W/, message: 'At least one special character' },
      { regex: /^.{8,15}$/, message: 'Between 8 to 15 characters long' },
    ];

    this.unmetCriteria = criteria
      .filter((criterion) => !criterion.regex.test(password))
      .map((criterion) => criterion.message);
  }

  private getColor(score: number) {
    let idx = 0;

    if (score > 90) {
      idx = 4;
    } else if (score > 70) {
      idx = 3;
    } else if (score >= 40) {
      idx = 2;
    } else if (score >= 20) {
      idx = 1;
    }

    return {
      idx: idx + 1,
      col: this.colors[idx],
    };
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    const password = changes['passwordToCheck'].currentValue;
    this.setBarColors(5, '#DDD');
    if (password) {
      let score = PasswordStrengthBarComponent.measureStrength(password);
      this.validatePassword(password); // Update unmet criteria
      const c = this.getColor(score);
      this.change.emit(score);
      this.setBarColors(c.idx, c.col);
    }
  }

  private setBarColors(count: number, col: any) {
    this.colorList = [];
    for (let _n = 0; _n < count; _n++) {
      this.colorList.push(col);
    }
  }
}
